const ThematicPackageStatus = {
  FIRST_SCIENTIFIC_CHECK: 'First Scientific Check',
  SECOND_SCIENTIFIC_CHECK: 'Second Scientific Check',
  FINAL_MOLECULAR_CHECK: 'Final Molecular Check',
  ANALYSIS_CHECK: 'Analysis Check',
  // SCIENTIFIC_TEXTS_CREATION: 'Scientific Text Creation',
  REPORT_CHECK: 'Package Report Creation',
  QUALITY_CHECK: 'Quality Check',
  COMMERCIAL_CHECK: 'Final Commercial Check',
  MANAGEMENT_CHECK: 'Management Check',
  DEPLOY_CHECK: 'Deploy Check',
  // PRODUCT: 'Product',
  FINAL: 'Final',
};

module.exports = {ThematicPackageStatus};
